import {
  ChangeDetectionStrategy,
  Component,
  inject,
  type OnInit,
} from '@angular/core';
import { QrDialogComponent } from '@components/dialog/qr-dialog/qr-dialog.component';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'market-header-qr',
  standalone: true,
  imports: [QrDialogComponent],
  templateUrl: './header-qr.component.html',
  styleUrl: './header-qr.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderQrComponent implements OnInit {
  user = inject(AuthService).userInfo;

  ngOnInit(): void {}
}
